// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coupon-left-header-wrap{
    display: flex;
    align-items: center;
    gap: 4px;
}

.coupon-header-main-wrap{
    justify-content: space-between;
}

.coupon-right-wrap button{
    width: 233px;
    height: 71px;
    border-radius: 10px;
    background: #00A19B;
    border: none;
    outline: none;
    color: #FFFFFF;
    font-size: 22px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.coupon-right-wrap button:hover{
    background: #008081;
}



.create-coupon-main-wrap {
    margin-top: 24px;
}

.create-coupon-head {
    display: flex;
    align-items: center;
    gap: 10px;
}

.create-coupon-head h4 {
    font-size: 30px;
    color: #1A1919;
    font-weight: 700;
    margin: 0px;
}

.create-coupon-head img{
    width: 36px;
    cursor: pointer;
}

.create-coupon-head img:hover{
    scale: 0.9;
}

.create-coupon-inner-wrapper {
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    margin-top: 38px;
    padding: 36px 65px;
}

.create-coupon-inner-wrap h4 {
    font-size: 24px;
    font-weight: 700;
    margin: 0px;
    color: #1A1919;
}

.coupon-input-fields{
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 22px;
}

.coupon-textarea-fields{
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 22px;   
}


.coupon-textarea-fields textarea{
    width: 100%;
    height: 124px;
    border: 1px solid #F3F3F3;
    border-radius: 13px;
    resize: none;
    padding: 20px 20px;
    font-size: 12px;
    color: #626262;
    outline: none;
    margin-top: 40px;
}

.create-coupon-save-button-wrapper{
    text-align: center;
    width: 405px;
    margin: 0 auto;
    margin-top: 40px;
}

.create-coupon-save-button-wrapper button{
    height: 49px;
    cursor: pointer;
}


.coupon-input-fields .react-dropdown .react-dropdown-btn {
    padding: 5px;
    padding: 0 15px !important;
    width: 100%;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: 9px;
    background: #fff;
    font-size: 14px;
    border: 1px solid #f3f3f3;
}

.coupon-input-fields .react-dropdown .dropdown-content .dropdown-item{
    width: 95%;
}

.coupon-input-fields .react-dropdown .dropdown-content {
    width: 100%;
    z-index: 999;
}

.coupon-input-fields .react-dropdown-btn .selected-item p {
    font-size: 14px;
}

.coupon-input-fields img.dropdown-down-arrow {
    width: 12px;
}

.coupon-input-fields .select-box-wrapper label {
    font-size: 14px;
    color: #1A1919;
    font-weight: 600;
    padding-left: 12px;
    margin: 0px;
    padding-bottom: 6px;
}

.coupon-input-fields{
    margin-top: 42px;
}


.coupon-input-fields .custom-date-input{
    margin-top: 30px;
    position: relative;
}

.coupon-input-fields .custom-date-input input::placeholder{
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
}

.coupon-input-fields .custom-date-input input{
    width: 100%;
    font-size: 14px;
    border: 1px solid #f3f3f3;
    margin-bottom: 0px;
    color: #1A1919;
    padding-left: 40px;
}


.coupon-input-fields .custom-date-input input::placeholder{
    color: #626262;
}


.coupon-input-fields .react-datepicker-wrapper {
    width: 100%;
}

.coupon-input-fields .date-input-wrap img {
    position: absolute;
    width: 35px;
    top: 14px;
    right: 10px;
    z-index: 99;
    cursor: pointer;
}


.coupon-input-fields .custom-date-input p {
    position: absolute;
    left: 14px;
    background-color: #fff;
    top: -8px;
    font-size: 12px;
    color: #626262;
    font-weight: 400;
}

.filter-date-input-wrap img {
    position: absolute;
    width: 35px;
    top: 20px;
    right: 10px;
    z-index: 99;
    cursor: pointer;
}

.filter-date-input-wrap{
    width: 293px;
}

.filter-date-input-wrap input {
    border: 2px solid #00A19B;
    border-radius: 9px;
    height: 75px;
    padding: 12px;
    width: 293px;
    font-size: 20px;
    color: #606060;
    font-weight: 400;
    outline: none;
    padding-left: 16px;
    padding-top: 14px;
}

.filter-date-input-wrap input::placeholder {
    margin: 0px;
    font-size: 20px;
    color: #606060;
    font-weight: 400;
}

.filter-date-input-wrap label{
    font-size: 22px;
    color: #1A1919;
    font-weight: 500;
    padding-left: 12px;
    margin: 0px;
    padding-bottom: 6px;
}


.create-coupon-fields-wrap .date-input-wrap {
    position: relative;
    width: 100%;
    margin-top: 20px;
}


@media(min-width: 1024px) and (max-width: 1599px){
    .filter-date-input-wrap{
        width: 220px;
    }
    
    .filter-date-input-wrap input {
        width: 220px;
        height: 60px;
        font-size: 18px;
    }

    .filter-date-input-wrap input::placeholder {
        font-size: 18px;
    }

    .filter-date-input-wrap label {
        font-size: 18px;
    }

    .coupon-right-wrap button {
        width: 200px;
        height: 56px;
        border-radius: 9px;
        font-size: 18px;
    }

    .create-coupon-head h4 {
        font-size: 22px;
    }

    .create-coupon-head img {
        width: 32px;
    }

    .create-coupon-inner-wrap h4 {
        font-size: 20px;
        display: none;
    }

    .coupon-input-fields input{
        height: 62px;
    }

    .create-coupon-inner-wrapper {
        border: 2px solid #F8F8F8;
        border-radius: 24px;
        margin-top: 20px;
        padding: 20px 40px;
        padding-top: 0px;
    }

    .coupon-input-fields {
        display: grid;
        grid-template-columns: 33% 33% 33%;
        gap: 20px;
    }

    .coupon-input-fields {
        margin-top: 26px;
    }

    .coupon-textarea-fields textarea {
        margin-top: 10px;
    }

    .coupon-input-fields .field label::before {
        font-size: 14px;
        left: 16px;
        top: 20px;
    }

    .coupon-input-fields .login-wrapper .label-before, .field input:focus + label::before, .field input:valid + label::before {
        color: #626262;
        line-height: 20px;
        font-size: 12px;
        font-weight: 400;
    }

    .create-coupon-save-button-wrapper {
        width: 400px;
        margin-top: 20px;
    }
}

@media(min-width: 768px) and (max-width: 1199px){
    .coupon-input-fields .custom-date-input input {
        width: 100%;
        height: 58px;
        font-size: 14px;
        border: 1px solid #f3f3f3;
        margin-bottom: 0px;
        color: #1A1919;
    }

    .coupon-input-fields input{
        height: 58px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/coupon/coupon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;;AAGA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,kCAAkC;QAClC,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,SAAS;IACb;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".coupon-left-header-wrap{\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.coupon-header-main-wrap{\n    justify-content: space-between;\n}\n\n.coupon-right-wrap button{\n    width: 233px;\n    height: 71px;\n    border-radius: 10px;\n    background: #00A19B;\n    border: none;\n    outline: none;\n    color: #FFFFFF;\n    font-size: 22px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.coupon-right-wrap button:hover{\n    background: #008081;\n}\n\n\n\n.create-coupon-main-wrap {\n    margin-top: 24px;\n}\n\n.create-coupon-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.create-coupon-head h4 {\n    font-size: 30px;\n    color: #1A1919;\n    font-weight: 700;\n    margin: 0px;\n}\n\n.create-coupon-head img{\n    width: 36px;\n    cursor: pointer;\n}\n\n.create-coupon-head img:hover{\n    scale: 0.9;\n}\n\n.create-coupon-inner-wrapper {\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    margin-top: 38px;\n    padding: 36px 65px;\n}\n\n.create-coupon-inner-wrap h4 {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0px;\n    color: #1A1919;\n}\n\n.coupon-input-fields{\n    display: grid;\n    grid-template-columns: 33% 33% 33%;\n    gap: 22px;\n}\n\n.coupon-textarea-fields{\n    display: grid;\n    grid-template-columns: 50% 50%;\n    gap: 22px;   \n}\n\n\n.coupon-textarea-fields textarea{\n    width: 100%;\n    height: 124px;\n    border: 1px solid #F3F3F3;\n    border-radius: 13px;\n    resize: none;\n    padding: 20px 20px;\n    font-size: 12px;\n    color: #626262;\n    outline: none;\n    margin-top: 40px;\n}\n\n.create-coupon-save-button-wrapper{\n    text-align: center;\n    width: 405px;\n    margin: 0 auto;\n    margin-top: 40px;\n}\n\n.create-coupon-save-button-wrapper button{\n    height: 49px;\n    cursor: pointer;\n}\n\n\n.coupon-input-fields .react-dropdown .react-dropdown-btn {\n    padding: 5px;\n    padding: 0 15px !important;\n    width: 100%;\n    height: 62px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-radius: 9px;\n    background: #fff;\n    font-size: 14px;\n    border: 1px solid #f3f3f3;\n}\n\n.coupon-input-fields .react-dropdown .dropdown-content .dropdown-item{\n    width: 95%;\n}\n\n.coupon-input-fields .react-dropdown .dropdown-content {\n    width: 100%;\n    z-index: 999;\n}\n\n.coupon-input-fields .react-dropdown-btn .selected-item p {\n    font-size: 14px;\n}\n\n.coupon-input-fields img.dropdown-down-arrow {\n    width: 12px;\n}\n\n.coupon-input-fields .select-box-wrapper label {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 600;\n    padding-left: 12px;\n    margin: 0px;\n    padding-bottom: 6px;\n}\n\n.coupon-input-fields{\n    margin-top: 42px;\n}\n\n\n.coupon-input-fields .custom-date-input{\n    margin-top: 30px;\n    position: relative;\n}\n\n.coupon-input-fields .custom-date-input input::placeholder{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n}\n\n.coupon-input-fields .custom-date-input input{\n    width: 100%;\n    font-size: 14px;\n    border: 1px solid #f3f3f3;\n    margin-bottom: 0px;\n    color: #1A1919;\n    padding-left: 40px;\n}\n\n\n.coupon-input-fields .custom-date-input input::placeholder{\n    color: #626262;\n}\n\n\n.coupon-input-fields .react-datepicker-wrapper {\n    width: 100%;\n}\n\n.coupon-input-fields .date-input-wrap img {\n    position: absolute;\n    width: 35px;\n    top: 14px;\n    right: 10px;\n    z-index: 99;\n    cursor: pointer;\n}\n\n\n.coupon-input-fields .custom-date-input p {\n    position: absolute;\n    left: 14px;\n    background-color: #fff;\n    top: -8px;\n    font-size: 12px;\n    color: #626262;\n    font-weight: 400;\n}\n\n.filter-date-input-wrap img {\n    position: absolute;\n    width: 35px;\n    top: 20px;\n    right: 10px;\n    z-index: 99;\n    cursor: pointer;\n}\n\n.filter-date-input-wrap{\n    width: 293px;\n}\n\n.filter-date-input-wrap input {\n    border: 2px solid #00A19B;\n    border-radius: 9px;\n    height: 75px;\n    padding: 12px;\n    width: 293px;\n    font-size: 20px;\n    color: #606060;\n    font-weight: 400;\n    outline: none;\n    padding-left: 16px;\n    padding-top: 14px;\n}\n\n.filter-date-input-wrap input::placeholder {\n    margin: 0px;\n    font-size: 20px;\n    color: #606060;\n    font-weight: 400;\n}\n\n.filter-date-input-wrap label{\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 500;\n    padding-left: 12px;\n    margin: 0px;\n    padding-bottom: 6px;\n}\n\n\n.create-coupon-fields-wrap .date-input-wrap {\n    position: relative;\n    width: 100%;\n    margin-top: 20px;\n}\n\n\n@media(min-width: 1024px) and (max-width: 1599px){\n    .filter-date-input-wrap{\n        width: 220px;\n    }\n    \n    .filter-date-input-wrap input {\n        width: 220px;\n        height: 60px;\n        font-size: 18px;\n    }\n\n    .filter-date-input-wrap input::placeholder {\n        font-size: 18px;\n    }\n\n    .filter-date-input-wrap label {\n        font-size: 18px;\n    }\n\n    .coupon-right-wrap button {\n        width: 200px;\n        height: 56px;\n        border-radius: 9px;\n        font-size: 18px;\n    }\n\n    .create-coupon-head h4 {\n        font-size: 22px;\n    }\n\n    .create-coupon-head img {\n        width: 32px;\n    }\n\n    .create-coupon-inner-wrap h4 {\n        font-size: 20px;\n        display: none;\n    }\n\n    .coupon-input-fields input{\n        height: 62px;\n    }\n\n    .create-coupon-inner-wrapper {\n        border: 2px solid #F8F8F8;\n        border-radius: 24px;\n        margin-top: 20px;\n        padding: 20px 40px;\n        padding-top: 0px;\n    }\n\n    .coupon-input-fields {\n        display: grid;\n        grid-template-columns: 33% 33% 33%;\n        gap: 20px;\n    }\n\n    .coupon-input-fields {\n        margin-top: 26px;\n    }\n\n    .coupon-textarea-fields textarea {\n        margin-top: 10px;\n    }\n\n    .coupon-input-fields .field label::before {\n        font-size: 14px;\n        left: 16px;\n        top: 20px;\n    }\n\n    .coupon-input-fields .login-wrapper .label-before, .field input:focus + label::before, .field input:valid + label::before {\n        color: #626262;\n        line-height: 20px;\n        font-size: 12px;\n        font-weight: 400;\n    }\n\n    .create-coupon-save-button-wrapper {\n        width: 400px;\n        margin-top: 20px;\n    }\n}\n\n@media(min-width: 768px) and (max-width: 1199px){\n    .coupon-input-fields .custom-date-input input {\n        width: 100%;\n        height: 58px;\n        font-size: 14px;\n        border: 1px solid #f3f3f3;\n        margin-bottom: 0px;\n        color: #1A1919;\n    }\n\n    .coupon-input-fields input{\n        height: 58px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
